/**
 *
 * Get data attribute from dom element
 *
 * @param DOM     element Element to retrieve data from
 * @param string  data to retrieve
 *
 * @return  string  data value
 *
 */

function getData( el, name ) {
	if( el == void 0 ) { console.warn( 'DOM element must be declared' ); return; }

	let data = el.getAttribute('data-' + name);

	if( data === '' || data === void 0 || data === 'false' || data === false ) {
		data = false;
	}
	else if( data === 'true' ) {
		data = true;
	}

	return data;
}

module.exports = getData;